import { createAgxForm, createFormDefinition } from '@urbanx/agx.forms';
import { z } from 'zod';
import { feesAndChargesSchema, rebatesSchema } from 'components/listing-agreement/lineItemSchemas';
import { resolveRebateFields } from 'components/listing-agreement/rebateFields';

export const ListingAgreementForm = createAgxForm(
  createFormDefinition({
    id: 'listing-agreement-settings',
    schema: z.object({
      eTag: z.string(),
      privacyPolicyLink: z.string(),
      feesAndCharges: feesAndChargesSchema,
      rebates: rebatesSchema,
    }),
    fieldOrder: ['privacyPolicyLink', 'feesAndCharges', 'rebates'],
    resolveFields: (values) => ({
      ...Object.fromEntries(
        values.feesAndCharges.flatMap((_, index) =>
          ['description', 'amount', 'whenPayable'].map((name) => [
            `feesAndCharges[${index}].${name}`,
            { active: true, visible: true, disabled: false, required: true },
          ])
        )
      ),
      ...resolveRebateFields(values.rebates),
    }),
  })
);
